/**
 * Converts a Uint8Array to a base64 string.
 * Works in both browser and Node.js environments.
 *
 * @param bytes The Uint8Array to encode
 * @returns Base64 encoded string
 */
export function uint8ArrayToBase64(bytes: Uint8Array): string {
  return typeof Buffer !== 'undefined'
    ? // Use Buffer in Node.js environment if available
      Buffer.from(bytes).toString('base64')
    : // Browser-compatible implementation using btoa
      btoa(Array.from(bytes, (byte) => String.fromCharCode(byte)).join(''))
}
